import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DbSaveService, GlobalUnitOfWork } from '@data';
import { MessageBusService } from '@core';
import { GlobalDbQueryService } from './global-db-query.service';

@Injectable({ providedIn: 'root' })
export class GlobalDbSaveService extends DbSaveService {
  constructor(
    public override uow: GlobalUnitOfWork,
    public dbQueryService: GlobalDbQueryService,
    public messageBusService: MessageBusService,
    http: HttpClient,
  ) {
    super(uow, http);
  }

  async postSendUserInvite(proximityUserId: string) {
    return this.postToUrl<string>('Login/SendConfirmationLink', null, { userId: proximityUserId });
  }

}
